import type { Product } from "@models/product";

export const PRODUCT_PLACEHOLDER_SRC = "/product-placeholder.svg";

export const getProductImage = (
    product: Pick<Product, "images">,
): string => {
    const url = product.images[0]?.url;
    return url && url.length > 0 ? url : PRODUCT_PLACEHOLDER_SRC;
};
